<template>
  <div class="col-md-12 col-sm-12 col-xs-12">
    <div class="row">
      <slot name="before"></slot>
    </div>
    <div class="row">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <p style="margin-bottom: 20px">
          Подачей настоящей заявки подтверждаю, что меры по обеспечению охраны и безопасноти
          на участках ограниченного доступа в пределах портового средства выполнены
        </p>
      </div>
    </div>
    <div class="row text-center form-send-button-block">
      <div class="col-md-3 col-sm-12 col-xs-12">
        <button
          type="button"
          class="btn btn-success btn-primary-white"
          :disabled="false"
          @click="createApplication"
          style="width: 100%"
        >
          Подать заявку
        </button>
      </div>
      <div class="col-md-3 col-sm-12 col-xs-12">
        <button
          type="button"
          class="btn btn-default btn-primary-white"
          :disabled="false"
          @click="draftApplication"
          style="width: 100%"
        >
          Сохранить черновик
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApplyApplicationFormBlock',

  methods: {
    createApplication () {
      this.$emit('create-application')
    },

    draftApplication () {
      this.$emit('draft-application')
    }
  }
};
</script>
